import { Engagement } from "@/react/components/Spaces/CourseSpace/AdminSummary/Engagement";
import { useAdminStats } from "@/react/components/Spaces/CourseSpace/AdminSummary/hooks/useAdminStats";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { Header } from "./Header";
import { Stats } from "./Stats";

export const AdminSummary = () => {
  const { data: space } = useCurrentSpaceContext();
  const { data: stats } = useAdminStats({ space });

  return (
    <div
      className="bg-primary h-full px-4 md:px-6"
      data-testid="course-dashboard"
    >
      <div className="mx-auto max-w-4xl space-y-6 py-8">
        <Header space={space} />
        <Stats space={space} stats={stats} />
        <Engagement space={space} />
      </div>
    </div>
  );
};
